import { computed } from 'vue';
import { usePrice as useBcomPrice } from '@common-vue/media-card-large/src/modules/price/components/bcom';
import { usePrice as useMcomPrice } from '@common-vue/media-card-large/src/modules/price/components';
import { useKillswitches } from '@modules/featureControl';
import { useBrand } from '@composables/useBrand';
import { usePageData } from '@composables/usePageData';
import { useLoyalty } from '@composables/useLoyalty';

/**
 *  usePrice parity between mcom / bcom
 * @param {object} param0
 * @param {import('@vueuse/core').MaybeRef<ProductId>} param0.id
 * @param {SelectedTraits.selectedColor | null} param0.selectedColor
 * @param {SelectedTraits.selectedSize | null} param0.selectedSize
 * @param {SelectedTraits.selectedUpcId | null} param0.selectedUpcId
 *
 * @returns {PdpSelectedPrice.selectedPrice}
 */
export function usePrice({
  id, selectedColor, selectedSize, selectedUpcId,
}) {
  const { isMcom } = useBrand();
  const price = isMcom ? useMcomPrice : useBcomPrice;
  const { shoppingMode, user } = usePageData();
  const { tierName } = useLoyalty();
  const { killswitches: { upcPricingForMarketplaceStandardPDPEnabled = false } } = useKillswitches();

  const userData = computed(() => ({
    tierName: tierName.value,
    shoppingMode,
    user,
  }));

  return price({
    id,
    selectedColor,
    selectedSize,
    selectedUpc: selectedUpcId,
    userData,
    uiKillswitches: { upcPricingForMarketplaceStandardPDPEnabled },
    priceSimplificationEnabled: true,
  });
}

export default usePrice;
